import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { State } from './types';
import {
    signInThunk,
    logOutThunk,
    getUserInfoThunk,
} from './thunks';

const isLoggedIn = localStorage.getItem('auth_status') === 'Authenticated' ? true : false;

const initialState: State = {
    isLoggedIn,
    userId: null,
    fetchStatus: 'Idle',
    loggingOut: false,
    logOutModal: false,
    accessToProtectedRoutes: !isLoggedIn,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
            state.isLoggedIn = action.payload;
        },
        setAccessToProtectedRoutes: (state, action: PayloadAction<boolean>) => {
            state.accessToProtectedRoutes = action.payload;
        },
        setLogOutModal: (state, action: PayloadAction<boolean>) => {
            state.logOutModal = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(signInThunk.pending, (state) => {
                state.fetchStatus = 'Pending';
            })
            .addCase(signInThunk.fulfilled, (state) => {
                state.fetchStatus = 'Idle';
                state.accessToProtectedRoutes = false;
            })
            .addCase(signInThunk.rejected, (state) => {
                state.fetchStatus = 'Rejected';
            })
            .addCase(getUserInfoThunk.pending, (state) => {
                state.fetchStatus = 'Pending';
            })
            .addCase(getUserInfoThunk.fulfilled, (state, action) => {
                state.userId = action.payload;
                state.isLoggedIn = true;
                state.fetchStatus = 'Idle';
                state.accessToProtectedRoutes = false;
            })
            .addCase(getUserInfoThunk.rejected, (state) => {
                state.userId = null;
                state.isLoggedIn = false;
                localStorage.clear();
                state.fetchStatus = 'Rejected';
                state.accessToProtectedRoutes = true;
            })
            .addCase(logOutThunk.pending, (state) => {
                state.loggingOut = true;
            })
            .addCase(logOutThunk.rejected, (state) => {
                state.loggingOut = false;
            })
            .addCase(logOutThunk.fulfilled, (state) => {
                state.loggingOut = false;
                state.isLoggedIn = false;
                state.logOutModal = false;
                state.accessToProtectedRoutes = true;
            })
    }
})

export const {
    setIsLoggedIn,
    setLogOutModal,
    setAccessToProtectedRoutes,
} = authSlice.actions;